import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DataTable, DataTableResource } from 'angular-4-data-table-bootstrap-4';

import { UscImpressionComponent } from '../usc-impression/usc-impression.component';
import { UscModalComponent } from '../usc-modal/usc-modal.component';

@Component({
  selector: 'sn-usc-lasting',
  templateUrl: '../usc-impression/usc-impression.component.html',
  styleUrls: ['../usc-store.component.css', './usc-lasting.component.css']
})
export class UscLastingComponent extends UscImpressionComponent {

  public orderBy:string = "cfd_cdr";
  view:string = this.uscStoreService.view_lasting;
  public view_interested:string = this.uscStoreService.form_last_interested;
  public view_not_interested:string = this.uscStoreService.form_last_not_interested;
  public view_call_back:string = this.uscStoreService.form_last_call_back;

  showOutcomeLog(item, outcome) {
    if (!this.uscStoreService.isUSCellRetail() && (outcome == this.view_purchase || outcome == this.view_future_sales)) {
      const modalRef = this.ngbModal.open(UscModalComponent, { backdrop: 'static', keyboard: false });
      modalRef.componentInstance.view = outcome;
      modalRef.componentInstance.data = item;
      modalRef.result.then((result) => {
        if (outcome == this.view_purchase) {
          this.showOutcomeLog(item, this.uscStoreService.form_future_sale);
        } else if (outcome == this.view_future_sales) {
          this.showPromptDlg(item, this.transition_new_referral);
        } else {
          this.pageItemsChecked = false;
          this.uscStoreService.setViewItemUpdated(item);
          this.reloadItems();
          }
      }, (reason) => {
        if (outcome == this.uscStoreService.form_future_sale) {
          this.showPromptDlg(item, this.transition_new_referral);
        }
      });
    } else {
      super.showOutcomeLog(item, outcome);
    }
  }
}




// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-lasting/usc-lasting.component.ts